import { create } from 'zustand'
import { nanoid } from 'nanoid'

export type ToastVariant = 'default' | 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  message: string
  description?: string
  variant: ToastVariant
  duration: number
}

interface ToastStore {
  toasts: Toast[]
  push: (input: { message: string; description?: string; variant?: ToastVariant; duration?: number }) => string
  dismiss: (id: string) => void
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  push: (input) => {
    const id = nanoid(8)
    const t: Toast = {
      id,
      message: input.message,
      description: input.description,
      variant: input.variant ?? 'default',
      duration: input.duration ?? 3500,
    }
    set((state) => ({ toasts: [...state.toasts, t] }))
    if (t.duration > 0) {
      setTimeout(() => {
        set((state) => ({ toasts: state.toasts.filter((x) => x.id !== id) }))
      }, t.duration)
    }
    return id
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))

// API conveniente
export const toast = {
  success: (message: string, description?: string) =>
    useToastStore.getState().push({ message, description, variant: 'success' }),
  error: (message: string, description?: string) =>
    useToastStore.getState().push({ message, description, variant: 'error', duration: 5000 }),
  warning: (message: string, description?: string) =>
    useToastStore.getState().push({ message, description, variant: 'warning' }),
  info: (message: string, description?: string) =>
    useToastStore.getState().push({ message, description, variant: 'info' }),
  show: (message: string, description?: string) =>
    useToastStore.getState().push({ message, description }),
}
